/* eslint-disable prefer-destructuring */
import { SafeEnv } from 'SharedDir/utils/helpers';

export const SERVER_API = SafeEnv(() => process.env.API_SERVER);
export const DADATA_KEY = SafeEnv(() => process.env.DADATA_API_KEY);

export const YANDEX_KEY = SafeEnv(() => process.env.YANDEX_API_KEY);

export const NOTIFICATIONS_SERVER_API = SafeEnv(() => process.env.API_SERVER_NOTIFICATIONS);

export const CENTRIFUGE_URL = SafeEnv(() => process.env.CENTRIFUGE_URL);

export const YANDEX_CAPTCHA_KEY = SafeEnv(() => process.env.YANDEX_CAPTCHA_API_KEY);

export const YANDEX_CAPTCHA_URL = SafeEnv(() => process.env.YANDEX_CAPTCHA_API_URL);
